import { BankingEntitiesCardPaymentRejectedReasonEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const rejectedReasonText = (reason: BankingEntitiesCardPaymentRejectedReasonEnum | null) => {
  switch (reason) {
    case 'account_disabled':
    case 'account_compliance_disabled':
    case 'account_inactive':
      return i18n.t('banking.card_payments.rejected_reason.account_disabled')
    case 'card_active':
      return i18n.t('banking.card_payments.rejected_reason.card_active')
    case 'card_canceled':
      return i18n.t('banking.card_payments.rejected_reason.card_canceled')
    case 'card_expired':
      return i18n.t('banking.card_payments.rejected_reason.card_expired')
    case 'card_inactive':
      return i18n.t('banking.card_payments.rejected_reason.card_inactive')
    case 'cardholder_blocked':
      return i18n.t('banking.card_payments.rejected_reason.cardholder_blocked')
    case 'cardholder_inactive':
      return i18n.t('banking.card_payments.rejected_reason.cardholder_inactive')
    case 'cardholder_verification_required':
      return i18n.t('banking.card_payments.rejected_reason.cardholder_verification_required')
    case 'insecure_authorization_method':
      return i18n.t('banking.card_payments.rejected_reason.insecure_authorization_method')
    case 'insufficient_funds':
      return i18n.t('banking.card_payments.rejected_reason.insufficient_funds')
    case 'not_allowed':
      return i18n.t('banking.card_payments.rejected_reason.not_allowed')
    case 'pin_blocked':
      return i18n.t('banking.card_payments.rejected_reason.pin_blocked')
    case 'spending_controls':
    case 'authorization_controls':
      return i18n.t('banking.card_payments.rejected_reason.spending_controls')
    case 'suspected_fraud':
      return i18n.t('banking.card_payments.rejected_reason.suspected_fraud')
    case 'verification_failed':
    case 'authentication_failed':
    case 'incorrect_cvc':
    case 'incorrect_expiry':
      return i18n.t('banking.card_payments.rejected_reason.verification_failed')
    case 'webhook_approved':
      return i18n.t('banking.card_payments.rejected_reason.webhook_approved')
    case 'webhook_declined':
      return i18n.t('banking.card_payments.rejected_reason.webhook_declined')
    case 'webhook_error':
      return i18n.t('banking.card_payments.rejected_reason.webhook_error')
    case 'webhook_timeout':
      return i18n.t('banking.card_payments.rejected_reason.webhook_timeout')
    case null:
      return ''
    default:
      reason satisfies never // every `reason` already handled line should never be hit
  }
}
